import { axios } from "@/lib/axios";

export type InviteRechargeTaskConfig = {
    firstRechargeRewardRate?: number | string;
    inviteRewardRate?: number | string;
    minOrderAmount?: number | string;
    minOrderCount?: number | string;
    rewardRate?: number | string;
    inviteeRegisterRewardAmount?: number | string;
    inviteeRegisterFixedRewardAmount?: number | string;
    inviterRegisterBonusRewardAmount?: number | string;
    registerGiveMoney?: number | string;
    nonFirstRechargeRewardRate?: number | string;
};

export type InviteTaskConfigResponse = {
    code?: number;
    msg?: string;
    total?: number;
    page?: number;
    data?: InviteRechargeTaskConfig;
    traceId?: string;
};

export function apiGetInviteTaskConfig() {
    return axios.get( "/api/front/user/invite-task/config" );
}

export type InviteCodeResponse = {
    code?: number;
    msg?: string;
    total?: number;
    page?: number;
    data?: string;
    traceId?: string;
};

export function apiGetInviteCode() {
    return axios.get( "/api/front/user/invite-task/invite-code" );
}

export function apiUpdateInviteCode( params: { inviteCode: string } ) {
    return axios.post( "/api/front/user/update/inviteCode/custom", params );
}

export type AgentProfitCommissionLevelItem = {
    id?: number;
    agentLevel?: number;
    level1Rate?: number | string;
    level2Rate?: number | string;
    level3Rate?: number | string;
    status?: number;
};

export type AgentProfitCommissionLevelResponse = {
    code?: number;
    msg?: string;
    total?: number;
    page?: number;
    data?: AgentProfitCommissionLevelItem[];
    traceId?: string;
};

export function apiGetAgentProfitCommissionLevels() {
    return axios.get( "/api/front/user/invite-task/agent-profit-commission-levels" );
}

export type InviteRechargeTaskItem = {
    level?: number;
    invitePersonCount?: number;
    currentInvitePersonCount?: number;
    singlePersonRechargeAmount?: number;
    rewardAmount?: number;
    levelComplete?: number;
    issueStatus?: number;
    currentInviteRechargePersonCount?: number;
    currentLevelInvitePersonCount?: number;
};

export type InviteTaskListResponse = {
    code?: number;
    msg?: string;
    total?: number;
    page?: number;
    data?: InviteRechargeTaskItem[];
    traceId?: string;
};

export function apiGetInviteTaskList() {
    return axios.get( "/api/front/user/invite-task/list" );
}

export type UserIndexItem = {
    totalInvitePersonCount?: number;
    totalRewardAmount?: number;
    inviteCode?: string;
    inviteRewardAmount?: number;
    firstRechargeRewardAmount?: number;
    rechargeTaskRewardAmount?: number;
    profitCommissionRewardAmount?: number;
    shareLinkData?: {
        shareTitle?: string;
        shareUrl?: string;
        shareText?: string;
    };
};

export type UserIndexResponse = {
    code?: number;
    msg?: string;
    total?: number;
    page?: number;
    data?: UserIndexItem;
    shareLinkData?: {
        shareTitle?: string;
        shareUrl?: string;
        shareText?: string;
    };
    traceId?: string;
};

export function apiGetInviteUserIndex() {
    return axios.get( "/api/front/user/invite-task/user-index" );
}

export type InviteeMoneyItem = {
    userId?: number;
    nickname?: string;
    avatar?: string;
    totalAmount?: string;
    registerTime?: number;
    activateStatus?: number;
};

export type InviteeRecordIndex = {
    inviteeCount?: number;
    activateUserCount?: number;
    inviteeMoneyItems?: InviteeMoneyItem[];
};

export type InviteeMonthlySummaryResponse = {
    code?: number;
    msg?: string;
    total?: number;
    page?: number;
    data?: InviteeRecordIndex;
    traceId?: string;
};

export function apiGetInviteMonthlySummary( month: number | string, params: {
    pageNum?: number;
    pageSize?: number;
} ) {
    return axios.get( `/api/front/user/invite-task/monthly-summary/${month}`, { params } );
}

export type InviteeWaterItem = {
    createTime?: string;
    changeDesc?: number;
    changeValue?: number;
};

export type InviteeMoneyListResponse = {
    code?: number;
    msg?: string;
    total?: number;
    page?: number;
    data?: InviteeWaterItem[];
    traceId?: string;
};

export function apiGetInviteeMoneyList( month: number | string, params: {
    pageNum?: number;
    pageSize?: number;
    inviteeUserId: number;
} ) {
    return axios.get( `/api/front/user/invite-task/invitee-money-list/${month}`, { params } );
}

export type InviteRuleDescriptionResponse = {
    code?: number;
    msg?: string;
    total?: number;
    page?: number;
    data?: string;
    traceId?: string;
};

export function apiGetInviteRuleDescription() {
    return axios.get( "/api/front/user/invite-task/rule-description" );
}
